import React from 'react'
import { Button } from 'styles/algolia/button'
import { ViewToggle, Row } from './styles'
import type { ConnectorProps as HeaderProps } from '../../connectors/Header'
import HeaderConnector from '../../connectors/Header'

const ViewType = ({
  isPublic,
  toggleViewType,
  hasValidPermissions,
}: HeaderProps): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <ViewToggle
      {...{
        type: isPublic ? 'public' : 'private',
      }}
      onClick={toggleViewType}
    >
      {hasValidPermissions && (
        <Row>
          <span>View:</span>
          <Button data-type='private'>Private</Button>

          <Button data-type='public'>Public</Button>
        </Row>
      )}
    </ViewToggle>
  )
}

export default HeaderConnector(ViewType)